import type {
  BatchUpdateLlgPoliciesRequest,
  Configuration,
  SearchLogsHistogramInput,
  SearchLogsInput,
} from '@repo/api-gw-sdk';
import {
  LlgPoliciesApi,
  LogSourcesApi,
  LogSourcesPoliciesApi,
  SearchApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/logs';

export const logs = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const searchApi = new SearchApi(config);
  const logSourcesApi = new LogSourcesApi(config);
  const logSourcesPoliciesApi = new LogSourcesPoliciesApi(config);
  const llgPoliciesApi = new LlgPoliciesApi(config);

  return {
    useListSchemas: (resourceIds: string[]) =>
      httpClient.execute(
        searchApi.getLogsSchemas.bind(searchApi),
        baseUrl,
        '/schemas',
        currentProjectId,
        resourceIds
      ),
    useSearch: (
      searchLogsInput: SearchLogsInput,
      disableExecution?: boolean
    ) => {
      return httpClient.executeWithConfig(
        (...args: Parameters<typeof searchApi.searchLogs>) =>
          args[1].resourceIds.length && !disableExecution
            ? searchApi.searchLogs(...args)
            : Promise.resolve(undefined),
        baseUrl,
        '/search',
        {
          dedupingInterval: 120_000,
        },
        currentProjectId,
        searchLogsInput
      );
    },
    useSources: () =>
      httpClient.execute(
        logSourcesApi.listLogSources.bind(logSourcesApi),
        baseUrl,
        '/sources',
        currentProjectId
      ),
    policies: {
      useList: (pageIndex?: number, pageSize?: number) =>
        httpClient.execute(
          logSourcesPoliciesApi.listLogSourcesPolicies.bind(
            logSourcesPoliciesApi
          ),
          baseUrl,
          '/policies',
          currentProjectId,
          pageIndex,
          pageSize
        ),
      update: (batchUpdateLlgPoliciesRequest: BatchUpdateLlgPoliciesRequest) =>
        llgPoliciesApi.batchUpdateLlgPolicies(
          currentProjectId,
          batchUpdateLlgPoliciesRequest
        ),
    },
    useHistogram: (input: SearchLogsHistogramInput) =>
      httpClient.execute(
        (...args: Parameters<typeof searchApi.getLogsHistogram>) =>
          args[1].resourceIds.length
            ? searchApi.getLogsHistogram(...args)
            : Promise.resolve(undefined),
        baseUrl,
        '/histogram',
        currentProjectId,
        input
      ),
  };
};
